import { funnelFromPath } from '../../funnels/routing';
import type { FunnelId } from '../../funnels/config';

export function useFunnelContext() {
  return useState<FunnelId>('funnel', () => {
    if (import.meta.server) {
      const event = useRequestEvent();
      return (event?.context?.funnel as FunnelId) ?? 'baseline';
    }

    return funnelFromPath(globalThis.location.pathname);
  });
}
